<template>
  <section>
    <div class="z-card border-0 integration-page">
      <h2>{{ $t('integration.v2.68') }}</h2>

      <p>
        {{ $t('integration.v2.69') }}
      </p>
      <br />
      <h3>{{ $t('integration.v2.70') }}</h3>
      <p>
        {{ $t('integration.v2.71') }}
      </p>

      <ul class="list-unstyled integration-list-info">
        <li><b>URL:</b> https://my.zorra.com/api/v2/number-verifications/sms/init</li>
        <li><b>Content-Type:</b> application/json</li>
        <li><b>Method:</b> POST</li>
        <li><b>Body:</b> JSON</li>
        <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
      </ul>

      <p>
        {{ $t('integration.api.example') }}
      </p>

      <pre>
  <code class="json hljs">
  {
      <span class="hljs-attr">"number"</span>: <span class="hljs-string">"79123456789"</span>,
      <span class="hljs-attr">"code"</span>: <span class="hljs-string">"123"</span>,
      <span class="hljs-attr">"size"</span>: <span class="hljs-number">4</span>,
      <span class="hljs-attr">"region"</span>: <span class="hljs-number">"ru"</span>
  }

  </code>
</pre>

      <p>
        {{ $t('integration.v2.72') }}
      </p>

      <ul class="list-unstyled integration-list-info">
        <li>
          <b>number</b> - {{ $t('integration.v2.73') }}
          <u>{{ $t('integration.v2.74') }}</u>
        </li>
        <li><b>code</b> - {{ $t('integration.v2.75') }}</li>
        <li><b>size</b> - {{ $t('integration.v2.76') }}</li>
        <li><b>region</b> - {{ $t('integration.v2.77') }}</li>
      </ul>

      <p>{{ $t('integration.api.answer_example') }}</p>

      <pre>
  <code class="json hljs">
  {
      <span class="hljs-attr">"id"</span>: <span class="hljs-number">471152</span>,
      <span class="hljs-attr">"type"</span>: <span class="hljs-string">"sms"</span>,
      <span class="hljs-attr">"number"</span>: <span class="hljs-number">"79123456789"</span>,
      <span class="hljs-attr">"is_manual"</span>: <span class="hljs-number">true</span>,
      <span class="hljs-attr">"region"</span>: <span class="hljs-number">"ru"</span>
  }
  </code>
</pre>

      <ul class="list-unstyled integration-list-info">
        <li><b>id</b> - {{ $t('integration.v2.78') }}</li>
        <li><b>type</b> - {{ $t('integration.v2.79') }}</li>
        <li><b>number</b> - {{ $t('integration.v2.80') }}</li>
        <li><b>is_manual</b> - {{ $t('integration.v2.81') }}</li>
        <li><b>region</b> - {{ $t('integration.v2.82') }}</li>
      </ul>

      <br />

      <h3>{{ $t('integration.v2.83') }}</h3>

      <ul class="list-unstyled integration-list-info">
        <li><b>URL:</b> https://my.zorra.com/api/v2/number-verifications/sms/check</li>
        <li><b>Content-Type:</b> application/json</li>
        <li><b>Method:</b> POST</li>
        <li><b>Body:</b> JSON</li>
        <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
      </ul>

      <div class="api-doc-hint">
        <div class="flex">
          <div class="mr-2">&#128161;</div>
          <p>
            {{ $t('integration.v2.84') }} <br />
            {{ $t('integration.v2.85') }}
          </p>
        </div>
      </div>

      <p>
        {{ $t('integration.v2.86') }}
      </p>

      <p>
        {{ $t('integration.api.example') }}
      </p>

      <pre>
  <code class="json hljs">
  {

      <span class="hljs-attr">"number"</span>: <span class="hljs-string">"79123456789"</span>,
      <span class="hljs-attr">"value"</span>: <span class="hljs-string">"804509"</span>
  }
  </code>
</pre>

      <p>{{ $t('integration.v2.87') }}</p>

      <pre>
  <code class="json hljs">
  {

      <span class="hljs-attr">"success"</span>: <span class="hljs-number">true</span>,
      <span class="hljs-attr">"message"</span>: <span class="hljs-string">"Success"</span>
  }
  </code>
</pre>

      <p>{{ $t('integration.v2.88') }}</p>

      <pre>
    <code class="json hljs">
  {
      <span class="hljs-attr">"success"</span>: <span class="hljs-number">false</span>,
      <span class="hljs-attr">"message"</span>: <span class="hljs-string">"The given data was invalid."</span>,
      <span class="hljs-attr">"errors"</span>: {
        <span class="hljs-attr">"value"</span>: [
        {
          <span class="hljs-attr">"message"</span>: <span class="hljs-string">"Incorrect value"</span>,
          <span class="hljs-attr">"rule"</span>: <span class="hljs-string">"check_number_verification_value"</span>,
          <span class="hljs-attr">"parameters"</span>: [],
        }
      ]
    }
  }
    </code>
  </pre>

      <h2>{{ $t('integration.v2.89') }}</h2>

      <p>
        {{ $t('integration.v2.90') }}
      </p>

      <ul class="list-unstyled integration-list-info">
        <li><b>URL:</b> https://my.zorra.com/api/v2/number-verifications/phone/init</li>
        <li><b>Content-Type:</b> application/json</li>
        <li><b>Method:</b> POST</li>
        <li><b>Body:</b> JSON</li>
        <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
      </ul>

      <p>{{ $t('integration.api.example') }}</p>

      <pre>
    <code class="json hljs">
  {
      <span class="hljs-attr">"phone_id"</span>: <span class="hljs-number">3</span>,
      <span class="hljs-attr">"number"</span>: <span class="hljs-string">"79123456789"</span>,
      <span class="hljs-attr">"code"</span>: <span class="hljs-string">"12345"</span>,
      <span class="hljs-attr">"size"</span>: <span class="hljs-number">4</span>,
      <span class="hljs-attr">"region"</span>: <span class="hljs-string">"ru"</span>
  }
    </code>
  </pre>

      <p>
        {{ $t('integration.v2.91') }}
      </p>

      <ul class="list-unstyled integration-list-info">
        <li><b>phone_id</b> - {{ $t('integration.v2.119') }}</li>
        <li><b>number</b> - {{ $t('integration.v2.92') }}</li>
        <li>
          <b>code</b> - {{ $t('integration.v2.93') }} <u>size</u> {{ $t('integration.v2.94') }}
        </li>
        <li><b>size</b> - {{ $t('integration.v2.118') }}</li>
        <li><b>region</b> - {{ $t('integration.v2.97') }}</li>
      </ul>

      <p>
        {{ $t('integration.api.answer_example') }}
      </p>

      <pre>
    <code class="json hljs">
  {
      <span class="hljs-attr">"id"</span>: <span class="hljs-number">471175</span>,
      <span class="hljs-attr">"type"</span>: <span class="hljs-string">"phone"</span>,
      <span class="hljs-attr">"number"</span>: <span class="hljs-string">"79123456789"</span>,
      <span class="hljs-attr">"is_manual"</span>: <span class="hljs-number">true</span>,
      <span class="hljs-attr">"region"</span>: <span class="hljs-string">"en"</span>

  }
    </code>
  </pre>

      <ul class="list-unstyled integration-list-info">
        <li><b>id</b> - {{ $t('integration.v2.98') }}</li>
        <li><b>type</b> - {{ $t('integration.v2.99') }}</li>
        <li><b>number</b> - {{ $t('integration.v2.100') }}</li>
        <li><b>is_manual</b> - {{ $t('integration.v2.101') }}</li>
        <li><b>region</b> - {{ $t('integration.v2.102') }}</li>
      </ul>

      <h3>{{ $t('integration.v2.103') }}</h3>
      <ul class="list-unstyled integration-list-info">
        <li><b>URL:</b> https://my.zorra.com/api/v2/number-verifications/phone/check</li>
        <li><b>Content-Type:</b> application/json</li>
        <li><b>Method:</b> POST</li>
        <li><b>Body:</b> JSON</li>
        <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
      </ul>

      <div class="api-doc-hint">
        <div class="flex">
          <div class="mr-2">&#128161;</div>
          <p>
            {{ $t('integration.v2.104') }}
            <br />
            {{ $t('integration.v2.105') }}
          </p>
        </div>
      </div>

      <p>
        {{ $t('integration.v2.106') }}
      </p>

      <p>{{ $t('integration.api.example') }}</p>

      <pre>
    <code class="json hljs">
  {
      <span class="hljs-attr">"number"</span>: <span class="hljs-string">"79123456789"</span>,
      <span class="hljs-attr">"value"</span>: <span class="hljs-string">"804509"</span>

  }
    </code>
  </pre>

      <ul class="list-unstyled integration-list-info">
        <li><b>number</b> - {{ $t('integration.v2.107') }}</li>
        <li><b>value</b> - {{ $t('integration.v2.108') }}</li>
      </ul>

      <p>{{ $t('integration.v2.109') }}</p>

      <pre>
    <code class="json hljs">
  {
      <span class="hljs-attr">"success"</span>: <span class="hljs-number">true</span>,
      <span class="hljs-attr">"message"</span>: <span class="hljs-string">"Success"</span>

  }
    </code>
  </pre>

      <h2>{{ $t('integration.v2.110') }}</h2>

      <p>
        {{ $t('integration.v2.111') }}
      </p>

      <div class="api-doc-hint">
        <div class="flex">
          <div class="mr-2">&#128161;</div>
          <p>
            {{ $t('integration.v2.112') }}
          </p>
        </div>
      </div>

      <p>
        {{ $t('integration.v2.113') }}
      </p>

      <p>{{ $t('integration.v2.114') }}</p>
      <p>
        <b>URL</b> https://my.zorra.com/api/v2/number-verifications/numbers/<b>{number_id}</b>/use
      </p>

      <p>
        {{ $t('integration.v2.115') }}
      </p>

      <p>{{ $t('integration.v2.177') }}</p>
      <ul class="list-unstyled integration-list-info">
        <li><b>URL:</b> https://my.zorra.com/api/v2/number-verifications/voice/init</li>
        <li><b>Content-Type:</b> application/json</li>
        <li><b>Method:</b> POST</li>
        <li><b>Body:</b> JSON</li>
        <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
      </ul>

      <pre>
    <code class="json hljs">
  {
      <span class="hljs-attr">"number"</span>: <span class="hljs-number">79123456789</span>,
      <span class="hljs-attr">"region"</span>: <span class="hljs-string">"ru"</span>,
      <span class="hljs-attr">"code"</span>: <span class="hljs-number">1234</span>,
      <span class="hljs-attr">"size"</span>: <span class="hljs-number">3</span>,
      <span class="hljs-attr">"phone_id"</span>: <span class="hljs-number">62284</span>
  }
    </code>
  </pre>

      <ul class="list-unstyled integration-list-info">
        <li><b>number</b> - {{ $t('integration.v2.116') }}</li>
        <li><b>code</b> - {{ $t('integration.v2.117') }} <u>size</u>.</li>
        <li><b>size</b> - {{ $t('integration.v2.118') }}</li>
        <li><b>phone_id</b> - {{ $t('integration.v2.119') }}</li>
        <li><b>region</b> - {{ $t('integration.v2.120') }}</li>
      </ul>

      <p>{{ $t('integration.v2.121') }} <u>region</u>:</p>
      <ul class="list-unstyled integration-list-info">
        <li><b>1. ru</b> - {{ $t('integration.v2.122') }};</li>
        <li><b>2. en</b> - {{ $t('integration.v2.123') }};</li>

        <li><b>3. es</b> - {{ $t('integration.v2.124') }};</li>
        <li><b>4. fr</b> - {{ $t('integration.v2.125') }};</li>
        <li><b>5. it</b> - {{ $t('integration.v2.126') }};</li>
        <li><b>6. ja</b> - {{ $t('integration.v2.127') }};</li>
        <li><b>7. vn</b> - {{ $t('integration.v2.128') }};</li>
        <li><b>8. ph</b> - {{ $t('integration.v2.129') }};</li>
        <li><b>9. sv</b> - {{ $t('integration.v2.130') }};</li>
      </ul>

      <p>{{ $t('integration.v2.131') }}</p>

      <pre>
    <code class="json hljs">
  {
      <span class="hljs-attr">"id"</span>: <span class="hljs-number">471306</span>,
      <span class="hljs-attr">"type"</span>: <span class="hljs-string">"voice"</span>,
      <span class="hljs-attr">"number"</span>: <span class="hljs-string">"79182952427"</span>,
      <span class="hljs-attr">"is_manual"</span>: <span class="hljs-number">true</span>,
      <span class="hljs-attr">"region"</span>: <span class="hljs-string">"ru"</span>
  }
    </code>
  </pre>

      <ul class="list-unstyled integration-list-info">
        <li><b>id</b> - {{ $t('integration.v2.132') }}</li>
        <li><b>type</b> - {{ $t('integration.v2.133') }}</li>

        <li><b>number</b> - {{ $t('integration.v2.134') }}</li>
        <li><b>is_manual</b> - {{ $t('integration.v2.135') }}</li>
        <li><b>region</b> - {{ $t('integration.v2.136') }}</li>
      </ul>
      <br />
      <h3>{{ $t('integration.v2.137') }}</h3>

      <ul class="list-unstyled integration-list-info">
        <li><b>URL:</b> https://my.zorra.com/api/v2/number-verifications/voice/check</li>
        <li><b>Content-Type:</b> application/json</li>
        <li><b>Method:</b> POST</li>
        <li><b>Body:</b> JSON</li>
        <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
      </ul>

      <div class="api-doc-hint">
        <div class="flex">
          <div class="mr-2">&#128161;</div>
          <div>
            <p>
              {{ $t('integration.v2.138') }}
              <br />{{ $t('integration.v2.139') }}
            </p>
          </div>
        </div>
      </div>

      <p>{{ $t('integration.v2.140') }}</p>

      <p>{{ $t('integration.api.example') }}</p>

      <pre>
    <code class="json hljs">
  {
      <span class="hljs-attr">"number"</span>: <span class="hljs-number">79123456789</span>,
      <span class="hljs-attr">"value"</span>: <span class="hljs-number">804509</span>
  }
    </code>
  </pre>

      <p>{{ $t('integration.v2.141') }}</p>

      <pre>
    <code class="json hljs">
  {
      <span class="hljs-attr">"success"</span>: <span class="hljs-number">true</span>,
      <span class="hljs-attr">"message"</span>: <span class="hljs-string">"Success"</span>
  }
    </code>
  </pre>
    </div>
  </section>
</template>

<script>
  export default {};
</script>
<style lang="scss">
  @import '~@/assets/styles/scss/highlight/monokai';
  @import '~@/assets/styles/scss/pages/integration';
</style>
